import { render } from "./newsShare.vue?vue&type=template&id=583c40c6&scoped=true"
import script from "./newsShare.vue?vue&type=script&lang=js"
export * from "./newsShare.vue?vue&type=script&lang=js"

import "./newsShare.vue?vue&type=style&index=0&id=583c40c6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583c40c6"]])

export default __exports__